import { resolveI18n } from "../../commons/services/Translation"

export const InputTitleWidth = (i18n) => {
  return resolveI18n({ i18n, ko: "140px", en: "270px", vi: "200px" })
}

export const InputButtonWidthClass = (i18n) => {
  return resolveI18n({ i18n, ko: "w120", en: "w150", vi: "w150" })
}